import { Link } from "react-router-dom";
import PriceCard from "../../components/PriceCard";
import { useState } from "react";
import {
  firstTimeDriverPackages,
  locations,
} from "../../data/first-time-driver";
import LocationsTooltip from "../../components/LocationsTooltip";
import floridaHandbook from "@/assets/images/florida-driver-license-handbook.png";
import heroBanner from "@/assets/images/pages/first-time-driver.jpg";

const FirstTimeDriver = () => {
  const [hoveredLocation, setHoveredLocation] = useState(null);

  const handleLocationHover = (packageId) => {
    setHoveredLocation(packageId);
  };

  const handleLocationLeave = () => {
    setHoveredLocation(null);
  };

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">
                Online Courses and Exams for First Time Drivers in Florida
              </h1>
              <p className="banner-subheading">
                CHOOSE ONE OF OUR PACKAGES AND SAVE MONEY!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <h2
            className="text-center mb-0"
            style={{
              fontSize: "20px",
              lineHeight: "1.6",
              color: "var(--metro-yellow)",
            }}
          >
            You must be 18 years or older to register for the 4-Hour Drug and
            Alcohol course.
            <br style={{ marginTop: "10px" }} />
            If you are under 18 years old (14-17 years) please register for the{" "}
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: "20px", color: "var(--metro-yellow)", fontWeight: "bold" }}
            >
              6-Hour DETS course.
            </a>
          </h2>
        </div>
      </section>

      <section className="pb-4" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row g-4">
            {firstTimeDriverPackages.map((pkg) => (
              <div key={pkg.id} className={pkg.columnClass}>
                <div
                  className="h-100 p-4 text-center"
                  style={{
                    backgroundColor: "#252525",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    ...(pkg.isPackage && {
                      border: "2px solid var(--metro-yellow)",
                    }),
                  }}
                >
                  <h3 className="text-white mb-3">{pkg.title}</h3>
                  <div className="mb-3">
                    <span
                      className="display-5 fw-bold"
                      style={{ color: "var(--metro-yellow)" }}
                    >
                      {pkg.price}
                    </span>
                  </div>
                  <p className="text-white mb-3">{pkg.description}</p>

                  {pkg.savings && (
                    <div className="mb-3">
                      <span
                        className="badge fs-6 px-3 py-2"
                        style={{
                          backgroundColor: "var(--metro-yellow)",
                          color: "#111111",
                        }}
                      >
                        {pkg.savings}
                      </span>
                    </div>
                  )}

                  {pkg.note && (
                    <p className="text-white mb-3">
                      <small>{pkg.note}</small>
                    </p>
                  )}

                  {pkg.moreInfoLink && (
                    <div className="mb-3">
                      <Link
                        to={pkg.moreInfoLink}
                        className="text-decoration-none"
                        style={{ color: "var(--metro-yellow)" }}
                      >
                        (More info)
                      </Link>
                    </div>
                  )}

                  {pkg.viewLocationsLink && (
                    <div className="mb-3">
                      <LocationsTooltip
                        show={hoveredLocation === pkg.id}
                        onMouseEnter={() => handleLocationHover(pkg.id)}
                        onMouseLeave={handleLocationLeave}
                        locations={locations}
                        lang="en"
                      />
                    </div>
                  )}

                  <div style={{ marginTop: "auto" }}>
                    <Link
                      to={pkg.registerLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-lg px-4 py-2 fw-bold text-dark"
                      style={{ backgroundColor: "var(--metro-yellow)" }}
                    >
                      Register
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-4 py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container text-warning text-center">
          <h3 className="fw-bold mb-2">
            No need to wait in line at the DMV!
          </h3>
          <h3 className="fw-bold mb-0">
            Take your Florida DMV Permit Test ONLINE!
          </h3>
        </div>
      </section>

      <section className="py-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="p-4"
                style={{ backgroundColor: "#252525", borderRadius: "8px" }}
              >
                <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                  Course Details
                </h3>

                <p className="text-white mb-4">
                  For a full course description of the 4-Hour New Driver Drug
                  and Alcohol Course,
                  <Link
                    to="/first-time-driver-course"
                    className="text-decoration-none ms-1"
                    style={{ color: "var(--metro-yellow)" }}
                  >
                    please click here.
                  </Link>
                </p>

                <p className="text-white mb-4">
                  We, at Metro Traffic School know today's young adults are busy
                  with school, extra curricular activities, work, and studying,
                  therefore with you in mind we introduce to you the online
                  version of the Florida Drug and Alcohol Course. This program
                  was designed with all the above mentioned concerns in mind,
                  but also with the flexibility to complete the course at the
                  students schedule.
                </p>

                <p className="text-white mb-4">
                  Registration is easy, simply fill in the required information
                  on the registration page, choose a password and answer 10
                  security questions. (The security questions will appear
                  randomly during the course, and must be answered by you
                  correctly in order to verify that you are the person who is
                  taking this course.) ….and best of all you can begin as soon
                  as you complete the registration process.
                </p>

                <h4 className="mb-3" style={{ color: "var(--metro-yellow)" }}>
                  How does it work?
                </h4>

                <p className="text-white mb-4">
                  The course is divided up into sections ranging in time from
                  15-40 minutes. You can log on & off as many times as you like
                  and complete the course at your convenience. In order to
                  receive credit for a section you must complete the entire
                  section before logging off, if you do not want to continue.
                  Then when you log on again it will take you to the next
                  section. There is a 40 question "open book" test at the end.
                  You must get 80% (32 questions) correct to get credit for the
                  course. You are guaranteed to pass – Free retakes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="text-white mb-5 fs-5 text-center">
                Make a secure payment now using your debit or credit card.
              </p>
              <div className="row g-3 justify-content-center">
                <PriceCard
                  iconClass="fas fa-chalkboard-teacher fa-2x"
                  title="Classroom Course"
                  price="$50.00"
                  buttonText="Register for Classroom Course - $50.00"
                  buttonLink="https://classroom.metrotrafficschool.com/create-account/OA=="
                  buttonProps={{
                    className:
                      "btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary metro-btn-pulse",
                  }}
                />
                <PriceCard
                  iconClass="fas fa-laptop fa-2x"
                  title="Online Course"
                  price="$29.95"
                  buttonText="Register for Online Course - $29.95"
                  buttonLink="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzg0"
                  buttonProps={{
                    className:
                      "btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-secondary",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-5" style={{ backgroundColor: "#111111" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <a
                href={floridaHandbook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={floridaHandbook}
                  alt="Florida Driver License Handbook"
                  style={{
                    height: "250px",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FirstTimeDriver;
